// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-component-loading[data-v-e77d406c]{position:fixed;z-index:200;left:50%;top:50%;margin-left:-40px;margin-top:-160px}.page-component-loading .figure-loading[data-v-e77d406c]{position:relative;width:56px;height:56px;background:url(https://i.gsxcdn.com/1794235023_k3r2x7x6.gif) no-repeat;background-size:cover}", ""]);
// Exports
module.exports = exports;
